export var IDLE = 'IDLE';
export var SUCCESS = 'SUCCESS';
export var FAIL = 'FAIL';
export var LOADING = 'LOADING';
